<script lang="ts" setup>
import { computed } from 'vue';
import { FormBuilderContract } from '@/components/builder/form';
import { Definition, EmailType } from '.';

defineOptions({
    name: `${Definition.type}-presenter`
});

const props = defineProps({
  "builder": null,
  "component": null,
  "value": null
});

const emails = computed(() =>
    props.value?.split(';').map(e => e.trim()).filter(Boolean) ?? []
);
</script>

<template>
    <div v-if="emails.length">
        <span v-for="(email, idx) in emails" :key="idx" class="d-flex align-items-center">
            <i class="fa-light fa-envelope me-2"></i>
            <span>{{ email }}</span>
        </span>
    </div>
    <span v-else>-</span>
</template>

<style scoped>
.fa-envelope {
    font-size: 16px;
}
</style>
